module.exports = __webpack_public_path__ + "snigh-8dc2ac0f66951e34d69c.jpg";